















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class DetailPatent extends Vue {
  @Prop({ default: undefined }) detail: any;

  @Watch('detail', { immediate: true })
  onPatentChanged() {
    var self = this;
  }

  get childrens() {
    return this.detail.children
      .map((item: any) => {
        return item.name;
      })
      .join(', ');
  }

  get emptyPatent(): boolean {
    return !(Object.keys(this.detail).length === 0);
  }
}
